import { primaryColor, dangerColor } from 'assets/jss/material-dashboard-pro-react';

const storageSelectorStyles = () => ({
	selectorContainer: {
		margin: '10px 0 30px 0',
	},
	singleSelector: {
		display: 'inline-block',
		marginRight: '10px',
		cursor: 'pointer',
	},
	selected: {
		borderBottom: `2px solid ${primaryColor[0]}`,
		paddingBottom: '3px',
		'& p': {
			color: primaryColor[0],
		},
	},
	disabled: {
		cursor: 'no-drop',
		pointerEvents: 'none',
	},
	unavailable: {
		width: '22px',
		height: '100%',
		borderTop: `3px solid ${dangerColor[0]}`,
		transform: 'skewY(-25deg)',
		position: 'relative',
		bottom: '10px',
		left: '5px',
	},
});

export default storageSelectorStyles;
